import React from 'react';
import AuthorHeroRo from '../../components/ro/author/AuthorHeroRo';
import AuthorBioRo from '../../components/ro/author/AuthorBioRo';
import AuthorLinksRo from '../../components/ro/author/AuthorLinksRo';

const AuthorPageRo = () => (
  <main>
    <AuthorHeroRo />
    <AuthorBioRo />
    <AuthorLinksRo />
  </main>
);

export default AuthorPageRo;